import { render } from "./family_list.vue?vue&type=template&id=1b5d9ad4&scoped=true"
import script from "./family_list.vue?vue&type=script&lang=js"
export * from "./family_list.vue?vue&type=script&lang=js"

import "./family_list.vue?vue&type=style&index=0&id=1b5d9ad4&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5d9ad4"]])

export default __exports__